import { useQuery } from '@tanstack/react-query'
import { apiFetch, hasLiveApi } from '@/api/client'
import { getAccessToken, isDemoSession } from '@/auth/oidc'
import type { StaffMeCaller } from '@/app/staffAccess'
import { resolveBookmakerSessionFlag } from '@/lib/bookmakerSessionFlag'

type MeResponse = {
  status: number
  message: string
  data: StaffMeCaller & { sub?: string }
}

async function loadStaffMe(): Promise<StaffMeCaller> {
  if (!hasLiveApi() || isDemoSession() || !getAccessToken()) {
    return {}
  }
  const res = await apiFetch<MeResponse>('/v1/me', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: '{}',
  })
  const data = res.data ?? {}
  return {
    staffUserId: data.staffUserId,
    grants: data.grants ?? [],
    bookmakerSessionFlag: resolveBookmakerSessionFlag(data.bookmakerSessionFlag),
  }
}

/** Lab `profile.bookmakerSessionFlag` for the signed-in staff (owners → all). */
export function useBookmakerSessionFlag() {
  const { data } = useStaffMe()
  return resolveBookmakerSessionFlag(data?.bookmakerSessionFlag)
}

export function useStaffMe() {
  return useQuery({
    queryKey: ['staff-me'],
    queryFn: loadStaffMe,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    retry: false,
  })
}
